<template>
  <div>
    <!-- <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
     
    </div> -->
    <div v-if="loading">
      <div class="text-center pt-10">
        <v-progress-circular
          color="primary"
          indeterminate
          size="60"
        ></v-progress-circular>
      </div>
    </div>
    <div v-else>
      <div class="mb-0">
        <v-btn @click="$emit('close')" text color="primary">
          <v-icon>mdi-chevron-left</v-icon>
          กลับ
        </v-btn>
      </div>
      <div class="pa-5 pt-1">
        <div>
          <div class="text-center mt-4 mb-6" style="font-size: 20px">
            กรอก Password เพื่อยืนยันการแก้ไข
          </div>
        </div>

        <ValidationObserver ref="observer">
          <ValidationProvider
            :rules="{
              required: true,
            }"
            name="Password"
            v-slot="{ errors }"
          >
            <custom-input
              :type="'password'"
              v-model="input.password"
              :center="true"
              placeholder=""
              outlined
              :error-messages="errors"
            ></custom-input>
          </ValidationProvider>
        </ValidationObserver>
        <!-- <div class="text-center mb-2">
          <v-btn
            :loading="resendloading"
            color="primary"
            @click="resendotp"
            text
            >Resend OTP</v-btn
          >
        </div> -->

        <div class="mt-4 text-center">
          <v-btn
            :loading="saveloading"
            @click="submitPassword"
            style="font-size: 20px"
            class="text-capitalize"
            color="primary"
            dark
            >ยืนยัน</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loading: true,
      saveloading: false,
      resendloading: false,
      ref: "",
    };
  },
  computed: {
    input() {
      return this.$store.state.input;
    },
  },
  async mounted() {
    this.input.password = "";
    this.loading = false;
  },
  methods: {
    back() {
      this.query.tab = "profile";
      this.query.view = "PointManager";
    },
    submitPassword() {
      return new Promise(async (resolve) => {
        if (await this.$refs.observer.validate()) {
          var data = {
            memberId: this.$store.state.member.memberId,
            password: this.input.password,
          };
          this.saveloading = true;
          axios
            .post(this.serverUrl + "toacrm/validate-password", data, {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            })
            .then(async (response) => {
              this.saveloading = false;
              if (response.data.responsecode == 200) {
                // await this.$store.dispatch("sendMessage", "ลงทะเบียนสำเร็จ");
                // await this.$liff.closeWindow();
                this.$emit("nextstep");
              } else if (response.data.responsecode == 204) {
                await this.$swal.fire({ text: response.data.reason });
              } else {
                await this.$swal.fire({ text: response.data.reason });
                this.$liff.closeWindow();
              }
              resolve();
            });
        }
      });
    },
  },
};
</script>
<style>
</style>